module.exports = __webpack_public_path__ + "static/img/top1.da0f583.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top1.jpg
// module id = CHxV
// module chunks = 1